
import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsCo2Verbrauch() {
  const co2_emission_current = useStore((state)=>state.co2_emission_current);
  const co2_emission_planned = useStore((state)=>state.co2_emission_planned);
  
  if (!co2_emission_current){return <></>}

  return (
    <Statistics label={"CO₂ Verbrauch"} now={co2_emission_current} future={co2_emission_planned} unit={"kg/Jahr"} />
  )
}